import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

/**
 * MarketplaceStatsSection
 * Two visually distinct bands stacked as one section:
 *
 * Band 1 — teal background: "A marketplace you can actually see" + 4 stats
 * Band 2 — white background: "Put your skills on the map" + CTA buttons + app badges
 */

const STATS = [
    { value: "1", label: "Interactive map for every skill" },
    { value: "3", label: "Audiences: Service providers, Clients & Employers" },
    { value: "9+", label: "Service categories, hundreds of skills" },
    { value: "3", label: "Ways to access: Web, iOS & Android" },
];

const MarketplaceStatsSection = () => {
    const navigate = useNavigate();

    return (
        <Wrapper>
            {/* ── Band 1: teal stats ── */}
            <div className="teal-band">
                <div className="container py-5">
                    <h2 className="teal-title text-center mb-5">
                        A marketplace you can actually see
                    </h2>
                    <div className="row g-4 justify-content-center text-center">
                        {STATS.map((s) => (
                            <div key={s.label} className="col-6 col-md-3">
                                <p className="stat-value">{s.value}</p>
                                <p className="stat-label">{s.label}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Band 2: white CTA ── */}
            <div className="white-band">
                <div className="container py-5 text-center">
                    <h2 className="cta-title mb-3">Put your skills on the map</h2>
                    <p className="cta-subtitle mx-auto mb-4">
                        Join GigFalcon to hire trusted help nearby, offer your services, or
                        find your next gig — wherever you are.
                    </p>
                </div>
            </div>
        </Wrapper>
    );
};

export default MarketplaceStatsSection;

/* ── Styles ──────────────────────────────────────────────────────────────── */
const TEAL = "#0fd3bb";
const TEAL_BG = "#0fd3bb";
const DARK = "#1c1c2e";
const GREY = "#666666";

const Wrapper = styled.div`

  /* ── Teal band ── */
  .teal-band {
    background-color: ${TEAL_BG};
  }

  .teal-title {
    font-size: clamp(1.6rem, 3.5vw, 2.4rem);
    font-weight: 800;
    color: #ffffff;
    font-family: "MS_Bold", "Arial Black", sans-serif;
    line-height: 1.2;
  }

  .stat-value {
    font-size: clamp(2.8rem, 6vw, 4rem);
    font-weight: 800;
    color: #ffffff;
    font-family: "MS_Bold", "Arial Black", sans-serif;
    line-height: 1;
    margin-bottom: 10px;
  }

  .stat-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.88);
    line-height: 1.5;
    margin-bottom: 0;
  }

  /* ── White band ── */
  .white-band {
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
  }

  .cta-title {
    font-size: clamp(1.7rem, 3.5vw, 2.4rem);
    font-weight: 800;
    color: ${DARK};
    font-family: "MS_Bold", "Arial Black", sans-serif;
  }

  .cta-subtitle {
    font-size: 1rem;
    color: black;
    max-width: 480px;
    line-height: 1.6;
  }

  /* CTA buttons */
  .btn-primary-teal {
    background-color: ${TEAL};
    color: #ffffff;
    border: none;
    padding: 13px 32px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    min-width: 170px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #0bbea9;
    }
  }

  .btn-outline-dark-custom {
    background-color: #ffffff;
    color: ${DARK};
    border: 1.5px solid #cccccc;
    padding: 13px 32px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    min-width: 170px;
    transition: border-color 0.2s ease, color 0.2s ease;

    &:hover {
      border-color: ${TEAL};
      color: ${TEAL};
    }
  }

  /* App store badges */
  .store-badge {
    height: 44px;
    width: auto;
    border-radius: 8px;
  }
`;
